import React from 'react';

import sendToClipBoard from '../../../services/sendToClipboard';
import { DASHBOARD_ZONE_DOMAIN } from '../../../config/defaults';

import FirstChart from './FirstChart';
import MobileChart from './MobileChart';
import SecondChart from './SecondChart';
import Nps from './Nps';
import RatingMap from './RatingMap';
import QuestionsCount from './QuestionsCount';
import QuestionsResult from './QuestionsResult';
import Results from './Results';

import ModulePanel from '../../ModulePanel';

const View = ({
	event,
	isLoading = true,
	surveys = [],
	dates_data = [],
	satisfaction_ratio = 0,
	satisfaction_questions = {},
	survey_questions = {},
	avg_time,
	handleState,
	completes,
	onDeleteFeedback,
	nps,
	mobileCount,
}) => {
	return (
		<React.Fragment>
			<ModulePanel title={['Encuesta de satisfacción']}>
				<div>
					<span>
						Puedes encontrar tu encuesta para diligenciar en el siguiente link:{' '}
					</span>
					<div className="d-inline-block ml-3">
						<a
							className="mr-3"
							href={`/feedback/${event.id}`}
							target="_blank"
							rel="noopener noreferrer"
						>
							{DASHBOARD_ZONE_DOMAIN}/feedback/{event.id}
						</a>
						<button
							className="btn btn-outline-primary"
							onClick={() => {
								sendToClipBoard(
									`${DASHBOARD_ZONE_DOMAIN}/feedback/${event.id}`,
									'El vínculo ha sido copiado'
								);
							}}
						>
							<i className="fas fa-copy"></i>
						</button>
					</div>
				</div>
			</ModulePanel>

			{isLoading && (
				<div className="d-flex justify-content-center align-items-center">
					<i className="fas fa-spinner fa-spin fa-3x" />
				</div>
			)}

			{!isLoading && surveys.length === 0 && (
				<div className="alert alert-warning" role="alert">
					Nadie ha diligenciado tu encuesta aún
				</div>
			)}

			{!isLoading && surveys.length > 0 && (
				<div className="row">
					<div className="col-md-6">
						<FirstChart
							satisfaction_ratio={satisfaction_ratio}
							avg_time={avg_time}
						/>

						<RatingMap
							satisfaction_questions={satisfaction_questions}
							surveys={surveys}
							handleState={handleState}
						/>
					</div>

					<div className="col-md-6">
						<QuestionsCount total={surveys.length} completes={completes} />

						<MobileChart size={surveys.length} mobileCount={mobileCount} />

						<SecondChart dates_data={dates_data} />
					</div>

					<div className="col-md-12">
						<QuestionsResult
							survey_questions={survey_questions}
							surveys={surveys}
							handleState={handleState}
						/>
					</div>

					<div className="col-md-12">
						<Nps nps={nps} surveys={surveys} />
					</div>

					<div className="col-md-12">
						<Results
							surveys={surveys}
							handleState={handleState}
							onDeleteFeedback={onDeleteFeedback}
						/>
					</div>
				</div>
			)}
		</React.Fragment>
	);
};

export default View;
